/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A2Inputs */

const en_fc_home_faq_a2 = /** @type {(inputs: Fc_Home_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. FilmCraft is an independent, clean-room project from the ArtCraft team. It borrows the familiar Premiere-style workflow, not Adobe's code, and has no affiliation with Adobe.`)
};

/**
* | output |
* | --- |
* | "No. FilmCraft is an independent, clean-room project from the ArtCraft team. It borrows the familiar Premiere-style workflow, not Adobe's code, and has no aff..." |
*
* @param {Fc_Home_Faq_A2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a2 = /** @type {((inputs?: Fc_Home_Faq_A2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a2(inputs)
});
export { fc_home_faq_a2 as "fc.home.faq.a2" }